import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export function useVans() {
  return useQuery({ queryKey: ['vanStock', 'vans'], queryFn: async () => (await api.get('/api/van-stock/vans')).data.vans, staleTime: 60_000 });
}

export function useVanStock(userId) {
  return useQuery({
    queryKey: ['vanStock', 'van', userId],
    queryFn: async () => (await api.get(`/api/van-stock/van/${userId}`)).data,
    enabled: !!userId,
    staleTime: 0,
  });
}
